// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/cloud-off.js';

import { paths } from '../generated/cloud-off';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('cloud-off', Original, paths);
